<template>
  <div class="deliver">
    <!--    顶部信息-->
    <div class="d-flex align-items-center p-20 mt-20"
         style="box-sizing: border-box; height: 36px; background: #2C3E4B; border-radius: 10px;">
      <i class="iconfont icon-lajitong text-00B38A" style="font-size: 18px"></i>
      <div class="font-12 ml-4 single-ellipsis text-write" style="max-width: 210px">{{ '垃圾箱' + devInfo.doorNo || '-' }}</div>
<!--      <div class="font-12 br10 ml-8 text-write"-->
<!--           style="background: #00B38A; box-sizing: border-box; padding: 1px 4px">-->
<!--        农业废弃垃圾-->
<!--      </div>-->
      <div class="text-write font-12" style="margin-left: 28px">开门状态：<span class="text-00B38A font-14">{{ devInfo.isDoorOpen ? '打开' : '关闭' }}</span></div>
      <div class="text-write font-12" style="margin-left: 50px">满溢状态：<span class="text-00B38A font-14">{{ devInfo.isFull ? '满溢' : '正常' }}</span></div>
      <div class="text-write font-12" style="margin-left: 50px">箱体温度：<span class="text-00B38A font-14">{{ devInfo.temperature + '℃' }}</span></div>
      <div class="text-write font-12" style="margin-left: 50px">当前重量：<span class="text-00B38A font-14">{{ devInfo.currentWeightText }}</span></div>
    </div>

    <!--    时间搜索-->
    <HnDateSearch  :isPage="false" :defaultData="0" @update="dateUpdate" style="margin-top: 18px; margin-bottom: 10px" :timeList="[]" />

    <!--    列表-->
    <div v-if="toudiList.length">
      <div class="d-flex flex-column" v-for="item in toudiList">
        <div class="d-flex align-items-center p-20 mt-10"
             style="box-sizing: border-box; height: 36px; background: #2C3E4B; border-radius: 10px;">
          <i class="iconfont icon-time text-00B38A" style="font-size: 18px"></i>
          <div class="font-12 ml-4 single-ellipsis text-write" style="max-width: 210px">投递时间：<span class="text-00B38A">{{ item.touDiTime || '-' }}</span></div>

          <i class="iconfont icon-lajitong text-00B38A ml-22" style="font-size: 18px"></i>
          <div class="font-12 ml-4 single-ellipsis text-write" style="max-width: 210px">投递垃圾类型：<span class="text-00B38A">{{ item.wasteTypeName || '-' }}</span></div>

          <i class="iconfont icon-lajitong text-00B38A ml-22" style="font-size: 18px"></i>
          <div class="font-12 ml-4 single-ellipsis text-write" style="max-width: 210px">投递重量：<span class="text-00B38A">{{ item.weightText || '-' }}</span></div>

          <!--        <div class="font-12 text-00B38A" style="margin-left: auto; cursor: pointer" @click="viewVideo">查看投递视频></div>-->
        </div>

        <!--      <div class="d-flex align-items-center"-->
        <!--           style="box-sizing: border-box; background: #2C3E4B; border-radius: 10px; justify-content: space-evenly; padding: 16px 10px 20px 20px">-->
        <!--        <div class="h100 d-flex flex-column" style="flex: 1">-->
        <!--          <div class="font-14 text-write">桶外照片</div>-->

        <!--          &lt;!&ndash;          无数据&ndash;&gt;-->
        <!--          <div class="w100 d-flex flex-column align-items-center" v-if="false">-->
        <!--            <img :src="noDataImg" alt="" style="width: 70px; height: 70px; margin-top: -6px" />-->
        <!--            <p class="font-12 text-write">暂无图片</p>-->
        <!--          </div>-->
        <!--          &lt;!&ndash;          有数据&ndash;&gt;-->
        <!--          <div class="d-flex align-items-center" style="margin-top: 6px; gap: 9px" v-if="true">-->
        <!--            <div style="width: 124px; height: 76px; outline: 1px white solid" v-for="item in 3"></div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div style="width: 0; height: 76px; border: 1px solid #00B38A; margin-top: 25px"></div>-->
        <!--        &lt;!&ndash;          无数据&ndash;&gt;-->
        <!--        <div class="w100 d-flex flex-column align-items-center" v-if="false">-->
        <!--          <img :src="noDataImg" alt="" style="width: 70px; height: 70px; margin-top: -6px" />-->
        <!--          <p class="font-12 text-write">暂无图片</p>-->
        <!--        </div>-->
        <!--        &lt;!&ndash;          有数据&ndash;&gt;-->
        <!--        <div class="h100 d-flex flex-column ml-16" style="flex: 1">-->
        <!--          <div class="font-14 text-write">桶内照片</div>-->
        <!--          <div class="d-flex align-items-center" style="margin-top: 6px; gap: 10px">-->
        <!--            <div style="width: 124px; height: 76px; outline: 1px white solid" v-for="item in 3"></div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--      </div>-->
      </div>
    </div>

    <div v-else style="margin-top: 20px">
      <hn-emptyData text="暂无数据"  size= '130px' setType= 'col'></hn-emptyData>
    </div>

    <!-- 分页组件 -->
    <div style="margin-left: auto; margin-top: 10px; margin-bottom: 8px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next"
        :total="pagination.total">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import deliverVideo from "./deliverVideo.vue"
import {GetSmartGarbageRoomBoxTouDiPageList} from "../../../../api/apiModel/web";
export default {
  props: {
    info: {  // 修正 props 定义
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    info: {  // 修正 watch 监听
      handler(val) {
        if (val) {
          this.devInfo = val
          this.getList(val)
        }
      },
      immediate: true,
      deep: true
    }
  },
  data(){
    return {
      noDataImg: require("@/assets/imgs/noData/no_min_data.png"),
      date:[],
      picFromInfo:{
        devCode:'',
        pageIndex:1,
        pageSize:10,
        sTime:'',
        eTime:'',
        timeType:0,
        beginAlarmDate: null,
        endAlarmDate: null
      },
      picTotal:0,
      isPageShow:true,
      tableData: [],
      devInfo: {},
      toudiList: [],
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
    }
  },
  methods:{
    // 查询投递列表信息
    async getList(val) {
      await GetSmartGarbageRoomBoxTouDiPageList({
        smartGarbageRoomBoxId: val.id,
        pageSize: this.pagination.pageSize || 10,
        pageIndex: this.pagination.currentPage || 1,
        beginTouDiDate: this.picFromInfo.beginAlarmDate,
        endTouDiDate: this.picFromInfo.endAlarmDate
      }).then((res) => {
        if (res){
          this.toudiList = res.list
          this.pagination.total = res.totalCount
        }
      })
    },
    dateUpdate(data){
      Object.assign(this.picFromInfo,data)
      this.picFromInfo.beginAlarmDate = data.sTime
      this.picFromInfo.endAlarmDate = data.eTime

      this.getList(this.devInfo)
      // this.getTableData();
    },
    // handleCurrentChange(val) {
    //   this.picFromInfo.pageIndex = val;
    //   this.getTableData();
    // },
    async getTableData() {
      console.log('------------', this.props)

      return

      this.picFromInfo.devCode = this.devCode
      const res = await this.$api.IotJKBLHistoricalData(this.picFromInfo)
      this.tableData = res ?.list || []

      this.picTotal = res ?.totalCount || 0;
    },
    // 查看投递视频
    viewVideo() {
      this.showDialog(
        deliverVideo,
        { props: null },
        {
          width: "900px",
          title: "投递视频",
          dialog: {
            isBut: false,
            isCenter: true,
          },
        }
      );
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getList(this.devInfo)
    },

    // 当前页改变时触发
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList(this.devInfo)
    },
  },
  mounted() {
    this.getTableData();
  }
}
</script>

<style lang="scss" scoped>
.deliver{
  //height: 260px;
  display: flex;
  flex-direction: column;
}
.text-00ffc5{
  color: #00FFC5;
}
.text-FFA800{
  color: #FFA800;
}
.text-00B38A{
  color: #00B38A;
}
</style>